module.exports = __webpack_public_path__ + "img/phone.10068570.png";